import { useTranslation } from 'react-i18next';
import { CATEGORIES } from '@/mocks/categories';
import { CATEGORY_IMAGES } from '@/mocks/categoryImages';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t('category.title')}
        </h2>
        <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('category.subtitle')}</p>
      </div>

      <div className="mx-auto mt-6 max-w-lg">
        <CategoryDropdown />
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7">
        {CATEGORIES.map((cat) => (
          <a
            key={cat.key}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1 cursor-pointer"
          >
            <div className="aspect-square w-full overflow-hidden bg-background-100">
              <img
                src={CATEGORY_IMAGES[cat.key]}
                alt={t(`cat.${cat.key}`)}
                title={`${t(`cat.${cat.key}`)} — USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 px-3 py-2.5">
              <span className="truncate text-xs font-semibold text-foreground-800 md:text-sm">
                {t(`cat.${cat.key}`)}
              </span>
              <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-500 transition-transform group-hover:translate-x-0.5">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </div>
          </a>
        ))}
      </div>

      <p className="mt-6 text-center text-xs text-foreground-500">{t('main.note')}</p>
    </section>
  );
}